import { useMemo } from "react";
import { useGlobalSignalrGroupsStore } from "../../stores/globalSignalrGroupsStore/useGlobalSignalrGroupsStore";

export const useNavCounts = (navItems = []) => {
  const groups = useGlobalSignalrGroupsStore((state) => state.groups);

  const navItemsWithCounts = useMemo(() => {
    const applyCount = (item) => {
      const group = item.signalrCountKey
        ? groups[item.signalrCountKey]
        : undefined;

      const next = group ? { ...item, count: group.result } : { ...item };
      if (next.items?.length) {
        next.items = next.items.map(applyCount);
      }
      return next;
    };

    return navItems.map(applyCount);
  }, [navItems, groups]);

  return { navItemsWithCounts };
};
